import type { TFunction } from "i18next";

const pickerValidationKeys: Record<string, string> = {
    invalidDate: "validation:picker.invalidDate",
    disableFuture: "validation:picker.disableFuture",
    disablePast: "validation:picker.disablePast",
    shouldDisableDate: "validation:picker.shouldDisableDate",
    shouldDisableMonth: "validation:picker.shouldDisableMonth",
    shouldDisableYear: "validation:picker.shouldDisableYear",
    minDate: "validation:picker.minDate",
    maxDate: "validation:picker.maxDate",
    minutesStep: "validation:picker.minutesStep",
    minTime: "validation:picker.minTime",
    maxTime: "validation:picker.maxTime",
    shouldDisableTime: "validation:picker.shouldDisableTime",
};

export const getPickerValidationMessage = (reason: string | null, t: TFunction): string => {
    if (!reason) {
        return "";
    }
    return t(pickerValidationKeys[reason] ?? "validation:picker.invalid");
};
